export default "__VITE_ASSET__B_fhQ8i3__"